// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".player-info{text-align:center;font-size:9pt}.white-text{color:#fff}.block{display:block}", ""]);
// Exports
module.exports = exports;
